// @generated
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "edgeCaseDeviations", {
    enumerable: true,
    get: function() {
        return edgeCaseDeviations;
    }
});
const edgeCaseDeviations = [
    {
        deviationId: 436621211,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Freeform-literature-436621211',
        title: 'Freeform literature',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T07:56:36-0800',
        isTextEditable: false,
        legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/436621211',
        isShareable: true,
        isCommentable: true,
        isFavourited: true,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 1
        },
        media: {
            types: [
                {
                    t: 'preview',
                    r: -2,
                    s: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
                    h: 220,
                    w: 500
                }
            ]
        },
        textContent: {
            excerpt: 'There was once a moose.\nIt went into the moose town to moose some moose.\nIt failed.\nTo be moose is suffering...',
            html: {
                type: 'writer',
                features: ''
            }
        }
    },
    {
        deviationId: 533831233,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-3000x500-533831233',
        title: 'Thumb Test 3000x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:08:12-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 1
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttutd-1be1a9d7-5580-496c-809c-4f714ae57615.png',
            prettyName: 'thumb_test_3000x500_by_superbearpower_d8ttutd',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTcxIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0dXRkLTFiZTFhOWQ3LTU1ODAtNDk2Yy04MDljLTRmNzE0YWU1NzYxNS5wbmciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.qkeTACte9dv6UKzFOjnNLsdUS-lpkeaY7-DoS3UZpWA'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 25,
                    w: 150,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_302,h_100,x_149,y_0,scl_0.2,strp/<prettyName>-200h.png',
                    h: 100,
                    w: 302,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_171,strp/<prettyName>-300w.png',
                    h: 50,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_502,h_100,x_49,y_0,scl_0.2,strp/<prettyName>-250t.png',
                    h: 100,
                    w: 502,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_700,h_117,strp/<prettyName>-350t.png',
                    h: 117,
                    w: 700,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_800,h_133,strp/<prettyName>-400t.png',
                    h: 134,
                    w: 800,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_171,strp/<prettyName>-fullview.png',
                    h: 171,
                    w: 1024,
                    o: true,
                    f: 51523
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_171,strp/<prettyName>-fullview.png',
                    h: 171,
                    w: 1024,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_171,strp/<prettyName>-fullview.png',
                    h: 171,
                    w: 1024,
                    o: true,
                    f: 51523
                }
            ]
        }
    },
    {
        deviationId: 436648517,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Deviation-with-lots-of-comments-436648517',
        title: 'Deviation with lots of comments',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T10:55:55-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 18,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d77yw5h-25114253-c211-4a46-b12d-b74062de593e.png',
            prettyName: 'deviation_with_lots_of_comments_by_superbearpower_d77yw5h',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTc2IiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kNzd5dzVoLTI1MTE0MjUzLWMyMTEtNGE0Ni1iMTJkLWI3NDA2MmRlNTkzZS5wbmciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.zG81hHdm_CgtvdxbBvAhfiykBeQ7bPT7mAJ_gtOfsdY'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 84,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_576,q_70,strp/<prettyName>-300w.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_445,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 444
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_623,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 622
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 711
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_576,q_80,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024,
                    f: 273744
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_576,q_80,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_576,q_80,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024,
                    f: 273744
                }
            ]
        }
    },
    {
        deviationId: 436649067,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Deviation-with-no-comments-436649067',
        title: 'Deviation with no comments',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T10:59:25-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: false,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d77ywkr-8ec6c295-b674-4782-8243-3aae926df6d4.jpg',
            prettyName: 'deviation_with_no_comments_by_superbearpower_d77ywkr',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDc3eXdrci04ZWM2YzI5NS1iNjc0LTQ3ODItODI0My0zYWFlOTI2ZGY2ZDQuanBnIiwiaGVpZ2h0IjoiPD01NzYiLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS53YXRlcm1hcmsiXSwid21rIjp7InBhdGgiOiJcL3dtXC8xZjE1NjEwMy0wODczLTQ3ZDktYTNjOC1kNjRiNjkzNzAyY2JcL3N1cGVyYmVhcnBvd2VyLTQucG5nIiwib3BhY2l0eSI6OTUsInByb3BvcnRpb25zIjowLjQ1LCJncmF2aXR5IjoiY2VudGVyIn19.lOYiE27rTOW3Bf_JBi7HwmANrL68bgfa9mSCLJ8prSw',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTc2IiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kNzd5d2tyLThlYzZjMjk1LWI2NzQtNDc4Mi04MjQzLTNhYWU5MjZkZjZkNC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.4ecfa3UjVanxO3_Mswa1b08mdejYAu0Cf6bO9DYomtk'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 84,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_576,q_70,strp/<prettyName>-300w.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_445,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 444
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_623,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 622
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 711
                },
                {
                    t: 'preview',
                    r: 1,
                    c: 'v1/fill/w_1024,h_576,q_75,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024,
                    f: 91457
                },
                {
                    t: 'social_preview',
                    r: 1,
                    c: 'v1/fill/w_1024,h_576,q_75,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_576,q_75,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024,
                    f: 91457
                }
            ]
        }
    },
    {
        deviationId: 533828730,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x2000-533828730',
        title: 'Thumb Test 500x2000',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:48:26-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsvu-0b7a8c5c-a48c-4269-8cb2-2de1c23382cc.jpg',
            prettyName: 'thumb_test_500x2000_by_superbearpower_d8ttsvu',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjAwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN2dS0wYjdhOGM1Yy1hNDhjLTQyNjktOGNiMi0yZGUxYzIzMzgyY2MuanBnIiwid2lkdGgiOiI8PTUwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.qZzO8yrXsNFuRUo932Owu-dKkKM2_n8XbhqxMHP5w_0',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN2dS0wYjdhOGM1Yy1hNDhjLTQyNjktOGNiMi0yZGUxYzIzMzgyY2MuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.joVwBl_TAlAKGttpMGA1jEy6a3Q7LZhvj2Vu1r_6EeU'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 38
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_100,h_201,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-200h.jpg',
                    h: 201,
                    w: 100
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
                    h: 900,
                    w: 225
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_100,h_251,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-250t.jpg',
                    h: 251,
                    w: 100
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/crop/w_100,h_351,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-350t.jpg',
                    h: 351,
                    w: 100
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_100,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 100
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_447,h_1788,q_70,strp/<prettyName>-pre.jpg',
                    h: 1788,
                    w: 447,
                    f: 283210
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_447,h_1788,q_70,strp/<prettyName>-pre.jpg',
                    h: 1788,
                    w: 447
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 2000,
                    w: 500,
                    f: 283210
                }
            ]
        }
    },
    {
        deviationId: 533828752,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x3000-533828752',
        title: 'Thumb Test 500x3000',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:48:42-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttswg-e025e414-1490-4780-80eb-8736ec0e3459.jpg',
            prettyName: 'thumb_test_500x3000_by_superbearpower_d8ttswg',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MzAwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN3Zy1lMDI1ZTQxNC0xNDkwLTQ3ODAtODBlYi04NzM2ZWMwZTM0NTkuanBnIiwid2lkdGgiOiI8PTUwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.-jdVLxh485dkIpkzvetNO3FiJm094Da33-Zij58-GHg',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN3Zy1lMDI1ZTQxNC0xNDkwLTQ3ODAtODBlYi04NzM2ZWMwZTM0NTkuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.R5DohwasTUSehaVxtyrkkKlHu2acmh1y_xUWWxhvhDs'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 25
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_100,h_201,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-200h.jpg',
                    h: 201,
                    w: 100
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
                    h: 900,
                    w: 150
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_100,h_251,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-250t.jpg',
                    h: 251,
                    w: 100
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/crop/w_100,h_351,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-350t.jpg',
                    h: 351,
                    w: 100
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/crop/w_100,h_401,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-400t.jpg',
                    h: 401,
                    w: 100
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_365,h_2190,q_70,strp/<prettyName>-pre.jpg',
                    h: 2190,
                    w: 365,
                    f: 423523
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_365,h_2190,q_70,strp/<prettyName>-pre.jpg',
                    h: 2190,
                    w: 365
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 3000,
                    w: 500,
                    f: 423523
                }
            ]
        }
    },
    {
        deviationId: 533828742,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x2500-533828742',
        title: 'Thumb Test 500x2500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:48:32-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsw6-2c6b482c-e603-4c5e-b2df-d5a8a47aa516.jpg',
            prettyName: 'thumb_test_500x2500_by_superbearpower_d8ttsw6',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjUwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN3Ni0yYzZiNDgyYy1lNjAzLTRjNWUtYjJkZi1kNWE4YTQ3YWE1MTYuanBnIiwid2lkdGgiOiI8PTUwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.qc2MwUiqApsT3sEpL4uvbBqtqJbPT28wvz3Bp51B7uk',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN3Ni0yYzZiNDgyYy1lNjAzLTRjNWUtYjJkZi1kNWE4YTQ3YWE1MTYuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.kXxrd_Rqx93lFMJPtGbZ-W7_55luquMiZGg4cYIe4xk'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 30
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_100,h_201,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-200h.jpg',
                    h: 201,
                    w: 100
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
                    h: 900,
                    w: 180
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_100,h_251,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-250t.jpg',
                    h: 251,
                    w: 100
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/crop/w_100,h_351,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-350t.jpg',
                    h: 351,
                    w: 100
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/crop/w_100,h_401,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-400t.jpg',
                    h: 401,
                    w: 100
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_400,h_2000,q_70,strp/<prettyName>-pre.jpg',
                    h: 2000,
                    w: 400,
                    f: 353947
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_400,h_2000,q_70,strp/<prettyName>-pre.jpg',
                    h: 2000,
                    w: 400
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 2500,
                    w: 500,
                    f: 353947
                }
            ]
        }
    },
    {
        deviationId: 533828705,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x1300-533828705',
        title: 'Thumb Test 500x1300',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:48:12-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsv5-18d225d2-ea98-434d-a019-f838f60c354b.jpg',
            prettyName: 'thumb_test_500x1300_by_superbearpower_d8ttsv5',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTMwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN2NS0xOGQyMjVkMi1lYTk4LTQzNGQtYTAxOS1mODM4ZjYwYzM1NGIuanBnIiwid2lkdGgiOiI8PTUwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.pxGUzbZWGNKUaCVNolVjjM-LcIHZXmKwIAhuIe1oJHs',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN2NS0xOGQyMjVkMi1lYTk4LTQzNGQtYTAxOS1mODM4ZjYwYzM1NGIuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.ExgwzPs9hoLvyQHhvPP2GLQGgwK-M1kzjTTN0EMM-Jk'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 58
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_100,h_201,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-200h.jpg',
                    h: 201,
                    w: 100
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
                    h: 780,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_100,h_251,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-250t.jpg',
                    h: 251,
                    w: 100
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/crop/w_135,h_350,x_0,y_0,scl_0.27,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 135
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_154,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 154
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1300,q_75,strp/<prettyName>-fullview.jpg',
                    h: 1300,
                    w: 500,
                    f: 184841
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1300,q_75,strp/<prettyName>-fullview.jpg',
                    h: 1300,
                    w: 500
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 1300,
                    w: 500,
                    f: 184841
                }
            ]
        }
    },
    {
        deviationId: 533828695,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x1100-533828695',
        title: 'Thumb Test 500x1100',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:47:56-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsuv-8b474046-1690-4b13-ba22-88552cb0ce48.jpg',
            prettyName: 'thumb_test_500x1100_by_superbearpower_d8ttsuv',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTEwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN1di04YjQ3NDA0Ni0xNjkwLTRiMTMtYmEyMi04ODU1MmNiMGNlNDguanBnIiwid2lkdGgiOiI8PTUwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.29LLAoCEgWteaQ8Y2MKlDeD_WQWbLdZkyjcEGJ3S0n4',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN1di04YjQ3NDA0Ni0xNjkwLTRiMTMtYmEyMi04ODU1MmNiMGNlNDguanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.M5NidR3QcWWhmgyPu7fMqw-ybRhG8D7ce2IHywPKrxY'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 68
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_100,h_201,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-200h.jpg',
                    h: 201,
                    w: 100
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
                    h: 660,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_114,h_250,x_0,y_0,scl_0.228,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 114
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_159,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 159
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_182,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 182
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1100,q_75,strp/<prettyName>-fullview.jpg',
                    h: 1100,
                    w: 500,
                    f: 156241
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1100,q_75,strp/<prettyName>-fullview.jpg',
                    h: 1100,
                    w: 500
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 1100,
                    w: 500,
                    f: 156241
                }
            ]
        }
    },
    {
        deviationId: 533828714,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x1500-533828714',
        title: 'Thumb Test 500x1500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:48:19-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsve-4d8e5080-af6b-4ad3-9868-0b5720ba2447.jpg',
            prettyName: 'thumb_test_500x1500_by_superbearpower_d8ttsve',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTUwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN2ZS00ZDhlNTA4MC1hZjZiLTRhZDMtOTg2OC0wYjU3MjBiYTI0NDcuanBnIiwid2lkdGgiOiI8PTUwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.XdeVEUk8zmlbxlzxRc8CXbmh5oxudocmLsLS7d5S-_s',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN2ZS00ZDhlNTA4MC1hZjZiLTRhZDMtOTg2OC0wYjU3MjBiYTI0NDcuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.bXAPbKXJzxcQwLpwqLAIJTjkq7_iHu_2wcanWzVcvr4'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 50
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_100,h_201,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-200h.jpg',
                    h: 201,
                    w: 100
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
                    h: 900,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_100,h_251,x_0,y_0,scl_0.2,q_70,strp/<prettyName>-250t.jpg',
                    h: 251,
                    w: 100
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/crop/w_117,h_350,x_0,y_0,scl_0.234,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 117
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/crop/w_133,h_400,x_0,y_0,scl_0.268,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 133
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1500,q_75,strp/<prettyName>-fullview.jpg',
                    h: 1500,
                    w: 500,
                    f: 212538
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1500,q_75,strp/<prettyName>-fullview.jpg',
                    h: 1500,
                    w: 500
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 1500,
                    w: 500,
                    f: 212538
                }
            ]
        }
    },
    {
        deviationId: 539180122,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-100x2000-539180122',
        title: 'Thumb Test 100x2000',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-06-12T09:58:59-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8x0i1m-03a85a0e-4724-44ae-881c-679f592e3149.jpg',
            prettyName: 'thumb_test_100x2000_by_superbearpower_d8x0i1m',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjAwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh4MGkxbS0wM2E4NWEwZS00NzI0LTQ0YWUtODgxYy02NzlmNTkyZTMxNDkuanBnIiwid2lkdGgiOiI8PTEwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.WVM_vyh1fuK8nvFJcH1Gc_k76hmwJHwF4-EbwlzCGtA',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh4MGkxbS0wM2E4NWEwZS00NzI0LTQ0YWUtODgxYy02NzlmNTkyZTMxNDkuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.lxXjP3zgo_-v8WRoHGE0toVsRPx4kxbiJoLK9gyhYGY'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_100,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 8
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_100,h_201,x_0,y_0,scl_1,q_70,strp/<prettyName>-200h.jpg',
                    h: 201,
                    w: 100
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fill/w_100,h_2000,q_75,strp/<prettyName>-fullview.jpg',
                    h: 2000,
                    w: 100
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_100,h_251,x_0,y_0,scl_1,q_70,strp/<prettyName>-250t.jpg',
                    h: 251,
                    w: 100
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/crop/w_100,h_351,x_0,y_0,scl_1,q_70,strp/<prettyName>-350t.jpg',
                    h: 351,
                    w: 100
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/crop/w_100,h_401,x_0,y_0,scl_1,q_70,strp/<prettyName>-400t.jpg',
                    h: 401,
                    w: 100
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_100,h_2000,q_75,strp/<prettyName>-fullview.jpg',
                    h: 2000,
                    w: 100,
                    f: 149024
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_100,h_2000,q_75,strp/<prettyName>-fullview.jpg',
                    h: 2000,
                    w: 100
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 2000,
                    w: 100,
                    f: 149024
                }
            ]
        }
    },
    {
        deviationId: 436623546,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Application-436623546',
        title: 'Application',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-03-05T10:43:08-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d77ycvu-71780098-775a-41c2-ba73-b7fdd3291071.png',
            prettyName: 'application_by_superbearpower_d77ycvu',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MzkyIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kNzd5Y3Z1LTcxNzgwMDk4LTc3NWEtNDFjMi1iYTczLWI3ZmRkMzI5MTA3MS5wbmciLCJ3aWR0aCI6Ijw9NDAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.Fwm1HvZnhN4MlxbcSpwDJMyYqFHHejwBo-mfTGVeWAw'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 147,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_204,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 204
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_392,q_70,strp/<prettyName>-300w.jpg',
                    h: 294,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_256,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 255
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_358,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 357
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_400,h_392,q_80,strp/<prettyName>-fullview.jpg',
                    h: 392,
                    w: 400
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_400,h_392,q_80,strp/<prettyName>-fullview.jpg',
                    h: 392,
                    w: 400,
                    f: 45982
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_400,h_392,q_80,strp/<prettyName>-fullview.jpg',
                    h: 392,
                    w: 400
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_400,h_392,q_80,strp/<prettyName>-fullview.jpg',
                    h: 392,
                    w: 400,
                    f: 45982
                }
            ]
        }
    },
    {
        deviationId: 436649619,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Deviation-with-print-436649619',
        title: 'Deviation with print',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T11:02:24-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d77yx03-f5e3d9f8-f979-41aa-aa95-0a3f1dd6644f.png',
            prettyName: 'deviation_with_print_by_superbearpower_d77yx03',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTc2IiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kNzd5eDAzLWY1ZTNkOWY4LWY5NzktNDFhYS1hYTk1LTBhM2YxZGQ2NjQ0Zi5wbmciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.pNC4mxvUYpBWyByIC9EqRhmAN1ej2BDJpJryZ2sfUl4'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 84,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_576,q_70,strp/<prettyName>-300w.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_445,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 444
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_623,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 622
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 711
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_576,q_80,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024,
                    f: 273744
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_576,q_80,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_576,q_80,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024,
                    f: 273744
                }
            ]
        }
    },
    {
        deviationId: 436651371,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Antisocial-deviation-436651371',
        title: 'Antisocial deviation',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T11:12:42-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: false,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: true,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d77yycr-c4a5eefc-b4bd-419c-80c2-67533f26022f.jpg',
            prettyName: 'antisocial_deviation_by_superbearpower_d77yycr',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDc3eXljci1jNGE1ZWVmYy1iNGJkLTQxOWMtODBjMi02NzUzM2YyNjAyMmYuanBnIiwiaGVpZ2h0IjoiPD01NzYiLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS53YXRlcm1hcmsiXSwid21rIjp7InBhdGgiOiJcL3dtXC8xZjE1NjEwMy0wODczLTQ3ZDktYTNjOC1kNjRiNjkzNzAyY2JcL3N1cGVyYmVhcnBvd2VyLTQucG5nIiwib3BhY2l0eSI6OTUsInByb3BvcnRpb25zIjowLjQ1LCJncmF2aXR5IjoiY2VudGVyIn19.Rn_9JvMxtEMxX6QsS1rSi3Sa6Lw475TKVlPgrqioex0',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTc2IiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kNzd5eWNyLWM0YTVlZWZjLWI0YmQtNDE5Yy04MGMyLTY3NTMzZjI2MDIyZi5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.1lRIZTH7qyXv5keZmSJafiBksc3RetrxCuATIgGdABM'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 84,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_576,q_70,strp/<prettyName>-300w.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_445,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 444
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_623,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 622
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 711
                },
                {
                    t: 'preview',
                    r: 1,
                    c: 'v1/fill/w_1024,h_576,q_75,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024,
                    f: 91457
                },
                {
                    t: 'social_preview',
                    r: 1,
                    c: 'v1/fill/w_1024,h_576,q_75,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_576,q_75,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024,
                    f: 91457
                }
            ]
        }
    },
    {
        deviationId: 436643421,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/ANSI-436643421',
        title: 'ANSI',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T10:25:55-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1f156103-0873-47d9-a3c8-d64b693702cb/d77ys7x-3bec8c47-b44d-4bac-bdfe-3bb8525447b3.png',
            prettyName: 'ansi_by_superbearpower_d77ys7x',
            types: [
                {
                    t: '150',
                    r: -1,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 94,
                    w: 150
                },
                {
                    t: '200H',
                    r: -1,
                    c: 'v1/fill/w_300,h_188,q_70,strp/<prettyName>-200h.jpg',
                    h: 188,
                    w: 300
                },
                {
                    t: '300W',
                    r: -1,
                    c: 'v1/fit/w_300,h_400,q_70,strp/<prettyName>-300w.jpg',
                    h: 188,
                    w: 300
                },
                {
                    t: '250T',
                    r: -1,
                    c: 'v1/fill/w_400,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 400
                },
                {
                    t: '350T',
                    r: -1,
                    c: 'v1/fill/w_560,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 560
                },
                {
                    t: '400T',
                    r: -1,
                    c: 'v1/fill/w_640,h_400,q_80,strp/<prettyName>-fullview.jpg',
                    h: 400,
                    w: 640
                },
                {
                    t: 'preview',
                    r: -1,
                    c: 'v1/fill/w_640,h_400,q_80,strp/<prettyName>-fullview.jpg',
                    h: 400,
                    w: 640,
                    f: 2129
                },
                {
                    t: 'social_preview',
                    r: -1,
                    c: 'v1/fill/w_640,h_400,q_80,strp/<prettyName>-fullview.jpg',
                    h: 400,
                    w: 640
                },
                {
                    t: 'fullview',
                    r: -1,
                    h: 400,
                    w: 640,
                    f: 2129
                }
            ]
        }
    },
    {
        deviationId: 533828667,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x500-533828667',
        title: 'Thumb Test 500x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:47:22-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsu3-3807975d-a2fe-40c4-a6b2-d353dba324ba.jpg',
            prettyName: 'thumb_test_500x500_by_superbearpower_d8ttsu3',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0c3UzLTM4MDc5NzVkLWEyZmUtNDBjNC1hNmIyLWQzNTNkYmEzMjRiYS5qcGciLCJ3aWR0aCI6Ijw9NTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.nf9HB47YP7Lnbacp7K6vGlycSZCGnm3yAZmbnpkCFPQ',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN1My0zODA3OTc1ZC1hMmZlLTQwYzQtYTZiMi1kMzUzZGJhMzI0YmEuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.RKFAOta3Yx-z6xiXRIbybKPoazW29KgdUFoc5m909lM'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_200,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 200
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_500,q_70,strp/<prettyName>-300w.jpg',
                    h: 300,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_250,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 250
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_350,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 350
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_400,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 400
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_500,q_75,strp/<prettyName>-fullview.jpg',
                    h: 500,
                    w: 500,
                    f: 72209
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_500,q_75,strp/<prettyName>-fullview.jpg',
                    h: 500,
                    w: 500
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 500,
                    w: 500,
                    f: 72209
                }
            ]
        }
    },
    {
        deviationId: 436649341,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Deviation-with-PCP-436649341',
        title: 'Deviation with PCP',
        isJournal: false,
        isPurchasable: true,
        publishedTime: '2014-02-25T11:01:21-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d77ywsd-c85a7024-98e3-40d4-b2c9-a0320f5823ea.jpg',
            prettyName: 'deviation_with_pcp_by_superbearpower_d77ywsd',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTc2IiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kNzd5d3NkLWM4NWE3MDI0LTk4ZTMtNDBkNC1iMmM5LWEwMzIwZjU4MjNlYS5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.rhbH89kMcfWpdnj4ixyPo0t_H3z7EP39mKI7oXwt-Io'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 84,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_576,q_70,strp/<prettyName>-300w.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_445,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 444
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_623,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 622
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 711
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_576,q_75,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024,
                    f: 91457
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_576,q_75,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_576,q_75,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024,
                    f: 91457
                }
            ]
        }
    },
    {
        deviationId: 533831177,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x2500-533831177',
        title: 'Thumb Test 500x2500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:07:08-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8tturt-aa6d1069-533d-43fe-8459-e383a7c9cba9.png',
            prettyName: 'thumb_test_500x2500_by_superbearpower_d8tturt',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjUwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVydC1hYTZkMTA2OS01MzNkLTQzZmUtODQ1OS1lMzgzYTdjOWNiYTkucG5nIiwid2lkdGgiOiI8PTUwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.UDE7nMpuAM_SR7Z0NlEqAZyQH89YYuZhLoh4UBHa6bw',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVydC1hYTZkMTA2OS01MzNkLTQzZmUtODQ1OS1lMzgzYTdjOWNiYTkucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.CzGIb_UM8bOzZ5lolAhEnhSTKgkQ9kfqi3ftQeWl-BY'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 150,
                    w: 30,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_100,h_201,x_0,y_0,scl_0.2,strp/<prettyName>-200h.png',
                    h: 201,
                    w: 100,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,strp/<prettyName>-300w.png',
                    h: 900,
                    w: 180,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_100,h_251,x_0,y_0,scl_0.2,strp/<prettyName>-250t.png',
                    h: 251,
                    w: 100,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/crop/w_100,h_351,x_0,y_0,scl_0.2,strp/<prettyName>-350t.png',
                    h: 351,
                    w: 100,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/crop/w_100,h_401,x_0,y_0,scl_0.2,strp/<prettyName>-400t.png',
                    h: 401,
                    w: 100,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_400,h_2000,strp/<prettyName>-pre.png',
                    h: 2000,
                    w: 400,
                    o: true,
                    f: 51935
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_400,h_2000,strp/<prettyName>-pre.png',
                    h: 2000,
                    w: 400,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 2500,
                    w: 500,
                    o: true,
                    f: 51935
                }
            ]
        }
    },
    {
        deviationId: 533831187,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x3000-533831187',
        title: 'Thumb Test 500x3000',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:07:15-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttus3-e7db0c49-5aa9-4a10-8f50-4e57dbcaf09f.png',
            prettyName: 'thumb_test_500x3000_by_superbearpower_d8ttus3',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MzAwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVzMy1lN2RiMGM0OS01YWE5LTRhMTAtOGY1MC00ZTU3ZGJjYWYwOWYucG5nIiwid2lkdGgiOiI8PTUwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.afvUi34WjX84u8omJYxb63eAHYZWlJWmEWh7Vq1QlpM',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVzMy1lN2RiMGM0OS01YWE5LTRhMTAtOGY1MC00ZTU3ZGJjYWYwOWYucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.G24ZioiGEprzNsPQlMJQNnRQcMfeHBBL0DXlmTMKj28'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 150,
                    w: 25,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_100,h_201,x_0,y_0,scl_0.2,strp/<prettyName>-200h.png',
                    h: 201,
                    w: 100,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,strp/<prettyName>-300w.png',
                    h: 900,
                    w: 150,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_100,h_251,x_0,y_0,scl_0.2,strp/<prettyName>-250t.png',
                    h: 251,
                    w: 100,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/crop/w_100,h_351,x_0,y_0,scl_0.2,strp/<prettyName>-350t.png',
                    h: 351,
                    w: 100,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/crop/w_100,h_401,x_0,y_0,scl_0.2,strp/<prettyName>-400t.png',
                    h: 401,
                    w: 100,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_365,h_2190,strp/<prettyName>-pre.png',
                    h: 2190,
                    w: 365,
                    o: true,
                    f: 61154
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_365,h_2190,strp/<prettyName>-pre.png',
                    h: 2190,
                    w: 365,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 3000,
                    w: 500,
                    o: true,
                    f: 61154
                }
            ]
        }
    },
    {
        deviationId: 533831171,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x2000-533831171',
        title: 'Thumb Test 500x2000',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:07:03-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8tturn-870e0e5d-4720-4858-bf12-db003adbdeba.png',
            prettyName: 'thumb_test_500x2000_by_superbearpower_d8tturn',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjAwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVybi04NzBlMGU1ZC00NzIwLTQ4NTgtYmYxMi1kYjAwM2FkYmRlYmEucG5nIiwid2lkdGgiOiI8PTUwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.Q3NOPUtea6TGztS4Pp2RYtDbY8Z78o0l_qlfyX4rGn4',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVybi04NzBlMGU1ZC00NzIwLTQ4NTgtYmYxMi1kYjAwM2FkYmRlYmEucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.g9kTwPatH7umiNgVGjciKRg_bOHaRKRJuqr3VSQVdPI'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 150,
                    w: 38,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_100,h_201,x_0,y_0,scl_0.2,strp/<prettyName>-200h.png',
                    h: 201,
                    w: 100,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,strp/<prettyName>-300w.png',
                    h: 900,
                    w: 225,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_100,h_251,x_0,y_0,scl_0.2,strp/<prettyName>-250t.png',
                    h: 251,
                    w: 100,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/crop/w_100,h_351,x_0,y_0,scl_0.2,strp/<prettyName>-350t.png',
                    h: 351,
                    w: 100,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_100,h_400,strp/<prettyName>-400t.png',
                    h: 400,
                    w: 100,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_447,h_1788,strp/<prettyName>-pre.png',
                    h: 1788,
                    w: 447,
                    o: true,
                    f: 42683
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_447,h_1788,strp/<prettyName>-pre.png',
                    h: 1788,
                    w: 447,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 2000,
                    w: 500,
                    o: true,
                    f: 42683
                }
            ]
        }
    },
    {
        deviationId: 533828660,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-250x250-533828660',
        title: 'Thumb Test 250x250',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:47:13-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttstw-dc43ad81-d817-448b-b5fc-c92c192d14f8.jpg',
            prettyName: 'thumb_test_250x250_by_superbearpower_d8ttstw',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjUwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0c3R3LWRjNDNhZDgxLWQ4MTctNDQ4Yi1iNWZjLWM5MmMxOTJkMTRmOC5qcGciLCJ3aWR0aCI6Ijw9MjUwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.cDmyGU8H5MT-lk2KRXpOxsy4EcipEikitEH5vNAtRhY',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN0dy1kYzQzYWQ4MS1kODE3LTQ0OGItYjVmYy1jOTJjMTkyZDE0ZjguanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.l34E5nSx9KwbtuL3vnQ_H6ZFV1ZIP9d7VQdpAnSWYMI'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_200,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 200
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fill/w_250,h_250,q_75,strp/<prettyName>-fullview.jpg',
                    h: 250,
                    w: 250
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_250,h_250,q_75,strp/<prettyName>-fullview.jpg',
                    h: 250,
                    w: 250
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_250,h_250,q_75,strp/<prettyName>-fullview.jpg',
                    h: 250,
                    w: 250
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_250,h_250,q_75,strp/<prettyName>-fullview.jpg',
                    h: 250,
                    w: 250
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_250,h_250,q_75,strp/<prettyName>-fullview.jpg',
                    h: 250,
                    w: 250,
                    f: 18877
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_250,h_250,q_75,strp/<prettyName>-fullview.jpg',
                    h: 250,
                    w: 250
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 250,
                    w: 250,
                    f: 18877
                }
            ]
        }
    },
    {
        deviationId: 533828654,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-100x100-533828654',
        title: 'Thumb Test 100x100',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:46:25-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttstq-d83c372f-e168-4b7f-8b6d-3423f2ee5ceb.jpg',
            prettyName: 'thumb_test_100x100_by_superbearpower_d8ttstq',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0c3RxLWQ4M2MzNzJmLWUxNjgtNGI3Zi04YjZkLTM0MjNmMmVlNWNlYi5qcGciLCJ3aWR0aCI6Ijw9MTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.zosvaEHCMF6nF1cGn5CcvVbMqFPGJ47HcYSRdSjQFZg',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN0cS1kODNjMzcyZi1lMTY4LTRiN2YtOGI2ZC0zNDIzZjJlZTVjZWIuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.AgvjowtQ7g_zJdNh1t_k7AGOi3jucMb34bJbvHzU3tw'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
                    h: 100,
                    w: 100
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
                    h: 100,
                    w: 100
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
                    h: 100,
                    w: 100
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
                    h: 100,
                    w: 100
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
                    h: 100,
                    w: 100
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
                    h: 100,
                    w: 100
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
                    h: 100,
                    w: 100,
                    f: 3662
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
                    h: 100,
                    w: 100
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 100,
                    w: 100,
                    f: 3662
                }
            ]
        }
    },
    {
        deviationId: 533831164,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x1500-533831164',
        title: 'Thumb Test 500x1500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:06:57-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8tturg-6f799ab1-9d5e-42e5-98f9-2bd478b88745.png',
            prettyName: 'thumb_test_500x1500_by_superbearpower_d8tturg',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTUwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVyZy02Zjc5OWFiMS05ZDVlLTQyZTUtOThmOS0yYmQ0NzhiODg3NDUucG5nIiwid2lkdGgiOiI8PTUwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.OY5Q18x8B6_5uYJUw1LW9PpCG-50UXnZGN1SyXF_jyA',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVyZy02Zjc5OWFiMS05ZDVlLTQyZTUtOThmOS0yYmQ0NzhiODg3NDUucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.uFfR8QW1x8Kouv2_owUsMiZX7jKW8fSLBxOxNpKYeVA'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 150,
                    w: 50,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_100,h_201,x_0,y_0,scl_0.2,strp/<prettyName>-200h.png',
                    h: 201,
                    w: 100,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,strp/<prettyName>-300w.png',
                    h: 900,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_100,h_251,x_0,y_0,scl_0.2,strp/<prettyName>-250t.png',
                    h: 251,
                    w: 100,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/crop/w_117,h_350,x_0,y_0,scl_0.234,strp/<prettyName>-350t.png',
                    h: 350,
                    w: 117,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/crop/w_133,h_400,x_0,y_0,scl_0.268,strp/<prettyName>-400t.png',
                    h: 400,
                    w: 133,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1500,strp/<prettyName>-fullview.png',
                    h: 1500,
                    w: 500,
                    o: true,
                    f: 33434
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1500,strp/<prettyName>-fullview.png',
                    h: 1500,
                    w: 500,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 1500,
                    w: 500,
                    o: true,
                    f: 33434
                }
            ]
        }
    },
    {
        deviationId: 533831159,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x1300-533831159',
        title: 'Thumb Test 500x1300',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:06:51-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8tturb-160bace0-3b2e-44d9-9c89-c55b34d6a308.png',
            prettyName: 'thumb_test_500x1300_by_superbearpower_d8tturb',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTMwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVyYi0xNjBiYWNlMC0zYjJlLTQ0ZDktOWM4OS1jNTViMzRkNmEzMDgucG5nIiwid2lkdGgiOiI8PTUwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.59TgNw-1mN4r8d7NPXJSVkd-Tbsh841Gv3XW5UsWfRU',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVyYi0xNjBiYWNlMC0zYjJlLTQ0ZDktOWM4OS1jNTViMzRkNmEzMDgucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.erk4DNw2zGCw-eGGV46qDBoj_dM3BtgDxGJMmNJnlF4'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 150,
                    w: 58,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_100,h_201,x_0,y_0,scl_0.2,strp/<prettyName>-200h.png',
                    h: 201,
                    w: 100,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,strp/<prettyName>-300w.png',
                    h: 780,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_100,h_251,x_0,y_0,scl_0.2,strp/<prettyName>-250t.png',
                    h: 251,
                    w: 100,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/crop/w_135,h_350,x_0,y_0,scl_0.27,strp/<prettyName>-350t.png',
                    h: 350,
                    w: 135,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_154,h_400,strp/<prettyName>-400t.png',
                    h: 400,
                    w: 154,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1300,strp/<prettyName>-fullview.png',
                    h: 1300,
                    w: 500,
                    o: true,
                    f: 29625
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1300,strp/<prettyName>-fullview.png',
                    h: 1300,
                    w: 500,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 1300,
                    w: 500,
                    o: true,
                    f: 29625
                }
            ]
        }
    },
    {
        deviationId: 533831152,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x1100-533831152',
        title: 'Thumb Test 500x1100',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:06:43-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttur4-5011c943-5ce5-42c3-a9bc-087a199965c0.png',
            prettyName: 'thumb_test_500x1100_by_superbearpower_d8ttur4',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTEwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVyNC01MDExYzk0My01Y2U1LTQyYzMtYTliYy0wODdhMTk5OTY1YzAucG5nIiwid2lkdGgiOiI8PTUwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.FTsmRY5Mgkr6JeCWRsiwC9etvSxd1zXVxvBZmCS6Dgg',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVyNC01MDExYzk0My01Y2U1LTQyYzMtYTliYy0wODdhMTk5OTY1YzAucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.JZhswD3WNVSpvxN-No6jNlhhETwl4jK3HqShtLCJzs4'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 150,
                    w: 68,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_100,h_201,x_0,y_0,scl_0.2,strp/<prettyName>-200h.png',
                    h: 201,
                    w: 100,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,strp/<prettyName>-300w.png',
                    h: 660,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_114,h_250,x_0,y_0,scl_0.228,strp/<prettyName>-250t.png',
                    h: 250,
                    w: 114,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_159,h_350,strp/<prettyName>-350t.png',
                    h: 350,
                    w: 159,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_182,h_400,strp/<prettyName>-400t.png',
                    h: 400,
                    w: 182,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1100,strp/<prettyName>-fullview.png',
                    h: 1100,
                    w: 500,
                    o: true,
                    f: 25750
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1100,strp/<prettyName>-fullview.png',
                    h: 1100,
                    w: 500,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 1100,
                    w: 500,
                    o: true,
                    f: 25750
                }
            ]
        }
    },
    {
        deviationId: 533828823,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-3000x500-533828823',
        title: 'Thumb Test 3000x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:49:55-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsyf-7dc9debe-1228-4bdf-9a7c-09086668dbb4.jpg',
            prettyName: 'thumb_test_3000x500_by_superbearpower_d8ttsyf',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTcxIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0c3lmLTdkYzlkZWJlLTEyMjgtNGJkZi05YTdjLTA5MDg2NjY4ZGJiNC5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.rARAF128VA-RtDe6_G9Gt_PqXybV8ybd-QE9l310Ys8'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 25,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_302,h_100,x_149,y_0,scl_0.2,q_70,strp/<prettyName>-200h.jpg',
                    h: 100,
                    w: 302
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_171,q_70,strp/<prettyName>-300w.jpg',
                    h: 50,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_502,h_100,x_49,y_0,scl_0.2,q_70,strp/<prettyName>-250t.jpg',
                    h: 100,
                    w: 502
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_700,h_117,q_70,strp/<prettyName>-350t.jpg',
                    h: 117,
                    w: 700
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_800,h_133,q_70,strp/<prettyName>-400t.jpg',
                    h: 134,
                    w: 800
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_171,q_75,strp/<prettyName>-fullview.jpg',
                    h: 171,
                    w: 1024,
                    f: 422394
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_171,q_75,strp/<prettyName>-fullview.jpg',
                    h: 171,
                    w: 1024
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_171,q_75,strp/<prettyName>-fullview.jpg',
                    h: 171,
                    w: 1024,
                    f: 422394
                }
            ]
        }
    },
    {
        deviationId: 533828815,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-2500x500-533828815',
        title: 'Thumb Test 2500x500 ',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:49:49-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsy7-b8ed3a15-a728-421c-abab-f17ff37a9f0c.jpg',
            prettyName: 'thumb_test_2500x500__by_superbearpower_d8ttsy7',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjA1IiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0c3k3LWI4ZWQzYTE1LWE3MjgtNDIxYy1hYmFiLWYxN2ZmMzdhOWYwYy5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.6NoQkHg8CnIhjB13Px2FH7soFXlvUX7PaQqVBPrbwkY'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 30,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_302,h_100,x_99,y_0,scl_0.2,q_70,strp/<prettyName>-200h.jpg',
                    h: 100,
                    w: 302
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_205,q_70,strp/<prettyName>-300w.jpg',
                    h: 60,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_500,h_100,q_70,strp/<prettyName>-250t.jpg',
                    h: 100,
                    w: 500
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_700,h_140,q_70,strp/<prettyName>-350t.jpg',
                    h: 140,
                    w: 700
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_800,h_160,q_70,strp/<prettyName>-400t.jpg',
                    h: 160,
                    w: 800
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_205,q_75,strp/<prettyName>-fullview.jpg',
                    h: 205,
                    w: 1024,
                    f: 352636
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_205,q_75,strp/<prettyName>-fullview.jpg',
                    h: 205,
                    w: 1024
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_205,q_75,strp/<prettyName>-fullview.jpg',
                    h: 205,
                    w: 1024,
                    f: 352636
                }
            ]
        }
    },
    {
        deviationId: 533828767,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-900x500-533828767',
        title: 'Thumb Test 900x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:48:54-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttswv-13b1e6f9-4ccd-4442-8e33-b2b1a7a64283.jpg',
            prettyName: 'thumb_test_900x500_by_superbearpower_d8ttswv',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0c3d2LTEzYjFlNmY5LTRjY2QtNDQ0Mi04ZTMzLWIyYjFhN2E2NDI4My5qcGciLCJ3aWR0aCI6Ijw9OTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.lQWDUG9Fb3JYaHpwkUP5CJp4UtgJKoWQIWEfD9NiED4',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN3di0xM2IxZTZmOS00Y2NkLTQ0NDItOGUzMy1iMmIxYTdhNjQyODMuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.hK0ZqEYQf5AWIyv_kg9A9S6n7IYdFwy35DmYJBs-ZgA'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 83,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_167,q_70,strp/<prettyName>-200h.jpg',
                    h: 167,
                    w: 300
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_500,q_70,strp/<prettyName>-300w.jpg',
                    h: 167,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_450,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 450
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_630,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 630
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_720,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 720
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_900,h_500,q_75,strp/<prettyName>-fullview.jpg',
                    h: 500,
                    w: 900,
                    f: 128524
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_900,h_500,q_75,strp/<prettyName>-fullview.jpg',
                    h: 500,
                    w: 900
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 500,
                    w: 900,
                    f: 128524
                }
            ]
        }
    },
    {
        deviationId: 533828759,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-700x500-533828759',
        title: 'Thumb Test 700x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:48:49-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttswn-4045e2f8-771f-47b9-9184-e75ba25392cb.jpg',
            prettyName: 'thumb_test_700x500_by_superbearpower_d8ttswn',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0c3duLTQwNDVlMmY4LTc3MWYtNDdiOS05MTg0LWU3NWJhMjUzOTJjYi5qcGciLCJ3aWR0aCI6Ijw9NzAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.odFkQPcBcz9psBGoHyNPu-LCOWi0V88u8EhNng9hkGk',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN3bi00MDQ1ZTJmOC03NzFmLTQ3YjktOTE4NC1lNzViYTI1MzkyY2IuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.filUw6A_iU-n1GMWuz0V2QLA9_NEOWNuLSN4l-QcFJQ'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 107,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_280,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 280
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_500,q_70,strp/<prettyName>-300w.jpg',
                    h: 214,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_350,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 350
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_490,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 490
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_560,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 560
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_700,h_500,q_75,strp/<prettyName>-fullview.jpg',
                    h: 500,
                    w: 700,
                    f: 99954
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_700,h_500,q_75,strp/<prettyName>-fullview.jpg',
                    h: 500,
                    w: 700
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 500,
                    w: 700,
                    f: 99954
                }
            ]
        }
    },
    {
        deviationId: 533828674,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x700-533828674',
        title: 'Thumb Test 500x700',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:47:30-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsua-65772434-e44b-495d-ad5b-a7becddde05f.jpg',
            prettyName: 'thumb_test_500x700_by_superbearpower_d8ttsua',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0c3VhLTY1NzcyNDM0LWU0NGItNDk1ZC1hZDViLWE3YmVjZGRkZTA1Zi5qcGciLCJ3aWR0aCI6Ijw9NTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0._duVou6BQV0mmy9qAKzvKxWP8dW8dBWlCbGz5UXdJ2I',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN1YS02NTc3MjQzNC1lNDRiLTQ5NWQtYWQ1Yi1hN2JlY2RkZGUwNWYuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.81ksRsKAPBu0wkgpE-3yHQbsQ1MgF0UgBUgawOxLXwY'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 107
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_143,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 143
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_700,q_70,strp/<prettyName>-300w.jpg',
                    h: 420,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_179,h_250,x_0,y_0,scl_0.358,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 179
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_250,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 250
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_286,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 286
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_700,q_75,strp/<prettyName>-fullview.jpg',
                    h: 700,
                    w: 500,
                    f: 100257
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_700,q_75,strp/<prettyName>-fullview.jpg',
                    h: 700,
                    w: 500
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 700,
                    w: 500,
                    f: 100257
                }
            ]
        }
    },
    {
        deviationId: 533828680,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x900-533828680',
        title: 'Thumb Test 500x900',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:47:44-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsug-21d9faca-eb8c-4ef7-9b86-1746d4a6b079.jpg',
            prettyName: 'thumb_test_500x900_by_superbearpower_d8ttsug',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0c3VnLTIxZDlmYWNhLWViOGMtNGVmNy05Yjg2LTE3NDZkNGE2YjA3OS5qcGciLCJ3aWR0aCI6Ijw9NTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.c3yywRmE56wbVZ93EgcA7hgc_BC-dumX2iZfbjevth8',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN1Zy0yMWQ5ZmFjYS1lYjhjLTRlZjctOWI4Ni0xNzQ2ZDRhNmIwNzkuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.1qutIRnBnsJ_Dz9ITLxzYU_lEV2ceWZdszaKvz-HD1E'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 83
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_111,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 111
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
                    h: 540,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_139,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 139
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/crop/w_194,h_350,x_0,y_0,scl_0.39,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 194
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_222,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 222
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_900,q_75,strp/<prettyName>-fullview.jpg',
                    h: 900,
                    w: 500,
                    f: 128631
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_900,q_75,strp/<prettyName>-fullview.jpg',
                    h: 900,
                    w: 500
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 900,
                    w: 500,
                    f: 128631
                }
            ]
        }
    },
    {
        deviationId: 533828687,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x1000-533828687',
        title: 'Thumb Test 500x1000',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:47:50-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsun-e5ae8b65-e1ef-463a-b28a-7927e9585bbb.jpg',
            prettyName: 'thumb_test_500x1000_by_superbearpower_d8ttsun',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTAwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN1bi1lNWFlOGI2NS1lMWVmLTQ2M2EtYjI4YS03OTI3ZTk1ODViYmIuanBnIiwid2lkdGgiOiI8PTUwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.-JRVAY8m5B2tCu5ljQvsIYDEqcScJGZ-Ci2x9NKOObs',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN1bi1lNWFlOGI2NS1lMWVmLTQ2M2EtYjI4YS03OTI3ZTk1ODViYmIuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.OMQJSfIJWr47nb1ZEFE77wpyUKqv26F2Quqo4_BqiLg'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 75
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_100,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 100
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
                    h: 600,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_125,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 125
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_175,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 175
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_200,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 200
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1000,q_75,strp/<prettyName>-fullview.jpg',
                    h: 1000,
                    w: 500,
                    f: 142692
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1000,q_75,strp/<prettyName>-fullview.jpg',
                    h: 1000,
                    w: 500
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 1000,
                    w: 500,
                    f: 142692
                }
            ]
        }
    },
    {
        deviationId: 436642384,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/PDF-436642384',
        title: 'PDF',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T10:19:16-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1f156103-0873-47d9-a3c8-d64b693702cb/d77yrf4-46cb5e61-e411-49b9-aff8-e5ea672e456f.png',
            prettyName: 'pdf_by_superbearpower_d77yrf4',
            types: [
                {
                    t: '150',
                    r: -1,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 147,
                    w: 150
                },
                {
                    t: '200H',
                    r: -1,
                    c: 'v1/fill/w_204,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 204
                },
                {
                    t: '300W',
                    r: -1,
                    c: 'v1/fit/w_300,h_450,q_70,strp/<prettyName>-300w.jpg',
                    h: 293,
                    w: 300
                },
                {
                    t: '250T',
                    r: -1,
                    c: 'v1/fill/w_256,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 256
                },
                {
                    t: '350T',
                    r: -1,
                    c: 'v1/fill/w_358,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 358
                },
                {
                    t: '400T',
                    r: -1,
                    c: 'v1/fill/w_409,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 409
                },
                {
                    t: 'preview',
                    r: -1,
                    c: 'v1/fill/w_460,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 460,
                    f: 45982
                },
                {
                    t: 'social_preview',
                    r: -1,
                    c: 'v1/fill/w_460,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 460
                },
                {
                    t: 'fullview',
                    r: -1,
                    h: 450,
                    w: 460,
                    f: 45982
                },
                {
                    t: 'pdf',
                    r: -2,
                    s: 'https://api-da.wixmp.com/_api/download/file?downloadToken=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsImV4cCI6MTU3ODQwMTk1MiwiaWF0IjoxNTc4NDAxMzQyLCJqdGkiOiI1ZTE0N2U0OGRlNDk0Iiwib2JqIjpudWxsLCJhdWQiOlsidXJuOnNlcnZpY2U6ZmlsZS5kb3dubG9hZCJdLCJwYXlsb2FkIjp7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDc3eXJmNC00ZTBjMDAxNy0zZDVjLTRhZTMtODI4MS04NzdhODg1MTVhOTAucGRmIn19.UixCW33TRYh7OqTcqSqZ--mkY5oWSn5ozqQ-Fz5h6qI',
                    h: 0,
                    w: 0,
                    f: 14702
                }
            ]
        }
    },
    {
        deviationId: 539179755,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-2000x100-539179755',
        title: 'Thumb Test 2000x100',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-06-12T09:57:21-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8x0hrf-fb012a7f-d5e9-4929-bb9c-6179f8b9af43.jpg',
            prettyName: 'thumb_test_2000x100_by_superbearpower_d8x0hrf',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTIiLCJwYXRoIjoiXC9mXC8xZjE1NjEwMy0wODczLTQ3ZDktYTNjOC1kNjRiNjkzNzAyY2JcL2Q4eDBocmYtZmIwMTJhN2YtZDVlOS00OTI5LWJiOWMtNjE3OWY4YjlhZjQzLmpwZyIsIndpZHRoIjoiPD0xMDI0In1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.tIlUrBk2yf7sii90VEaNNI3fxeGNAcCSS_MkQaOQxW4'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_52,q_70,strp/<prettyName>-150.jpg',
                    h: 8,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_302,h_100,x_849,y_0,scl_1,q_70,strp/<prettyName>-200h.jpg',
                    h: 52,
                    w: 302
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_52,q_70,strp/<prettyName>-300w.jpg',
                    h: 15,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_502,h_100,x_749,y_0,scl_1,q_70,strp/<prettyName>-250t.jpg',
                    h: 52,
                    w: 502
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/crop/w_702,h_100,x_649,y_0,scl_1,q_70,strp/<prettyName>-350t.jpg',
                    h: 52,
                    w: 702
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/crop/w_802,h_100,x_599,y_0,scl_1,q_70,strp/<prettyName>-400t.jpg',
                    h: 52,
                    w: 802
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_52,q_75,strp/<prettyName>-fullview.jpg',
                    h: 52,
                    w: 1024,
                    f: 105764
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_52,q_75,strp/<prettyName>-fullview.jpg',
                    h: 52,
                    w: 1024
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_52,q_75,strp/<prettyName>-fullview.jpg',
                    h: 52,
                    w: 1024,
                    f: 105764
                }
            ]
        }
    },
    {
        deviationId: 533828774,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-1000x500-533828774',
        title: 'Thumb Test 1000x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:49:04-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsx2-6816258b-7c01-4109-ab4f-45c169de36fd.jpg',
            prettyName: 'thumb_test_1000x500_by_superbearpower_d8ttsx2',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0c3gyLTY4MTYyNThiLTdjMDEtNDEwOS1hYjRmLTQ1YzE2OWRlMzZmZC5qcGciLCJ3aWR0aCI6Ijw9MTAwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.0t1-GNPPhb_9EfJVreK1uzzX45FnADQ5e__ufbLsBQ8',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHN4Mi02ODE2MjU4Yi03YzAxLTQxMDktYWI0Zi00NWMxNjlkZTM2ZmQuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.UEuW12nq9m9YfOWtvzfCD8jtj9eO_kgZ4E5vaQiaESA'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 75,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_150,q_70,strp/<prettyName>-200h.jpg',
                    h: 150,
                    w: 300
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_500,q_70,strp/<prettyName>-300w.jpg',
                    h: 150,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_500,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 500
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_700,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 700
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_800,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 800
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1000,h_500,q_75,strp/<prettyName>-fullview.jpg',
                    h: 500,
                    w: 1000,
                    f: 142696
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1000,h_500,q_75,strp/<prettyName>-fullview.jpg',
                    h: 500,
                    w: 1000
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 500,
                    w: 1000,
                    f: 142696
                }
            ]
        }
    },
    {
        deviationId: 533828796,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-1500x500-533828796',
        title: 'Thumb Test 1500x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:49:32-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsxo-fa35cc40-f718-43c4-a4bc-c2a0df4a699e.jpg',
            prettyName: 'thumb_test_1500x500_by_superbearpower_d8ttsxo',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MzQyIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0c3hvLWZhMzVjYzQwLWY3MTgtNDNjNC1hNGJjLWMyYTBkZjRhNjk5ZS5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.38hcsqgEWRT1QmV3mNRU1VwbUwtELx-i5-oz5LSm4TY'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 50,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_100,q_70,strp/<prettyName>-200h.jpg',
                    h: 100,
                    w: 300
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_342,q_70,strp/<prettyName>-300w.jpg',
                    h: 100,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_500,h_167,q_70,strp/<prettyName>-250t.jpg',
                    h: 167,
                    w: 500
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_700,h_233,q_70,strp/<prettyName>-350t.jpg',
                    h: 234,
                    w: 700
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_800,h_267,q_70,strp/<prettyName>-400t.jpg',
                    h: 267,
                    w: 800
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_342,q_75,strp/<prettyName>-fullview.jpg',
                    h: 342,
                    w: 1024,
                    f: 212309
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_342,q_75,strp/<prettyName>-fullview.jpg',
                    h: 342,
                    w: 1024
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_342,q_75,strp/<prettyName>-fullview.jpg',
                    h: 342,
                    w: 1024,
                    f: 212309
                }
            ]
        }
    },
    {
        deviationId: 533828804,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-2000x500-533828804',
        title: 'Thumb Test 2000x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:49:41-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsxw-ffd9cc75-014a-43fe-b95d-ab4119cf855e.jpg',
            prettyName: 'thumb_test_2000x500_by_superbearpower_d8ttsxw',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjU2IiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0c3h3LWZmZDljYzc1LTAxNGEtNDNmZS1iOTVkLWFiNDExOWNmODU1ZS5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.VX9II8RAb-fFCmYc1S598wZYwP6S3_mESc-_djSECvI'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 38,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_302,h_100,x_49,y_0,scl_0.2,q_70,strp/<prettyName>-200h.jpg',
                    h: 100,
                    w: 302
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_256,q_70,strp/<prettyName>-300w.jpg',
                    h: 75,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_500,h_125,q_70,strp/<prettyName>-250t.jpg',
                    h: 125,
                    w: 500
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_700,h_175,q_70,strp/<prettyName>-350t.jpg',
                    h: 175,
                    w: 700
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_800,h_200,q_70,strp/<prettyName>-400t.jpg',
                    h: 200,
                    w: 800
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_256,q_75,strp/<prettyName>-fullview.jpg',
                    h: 256,
                    w: 1024,
                    f: 282790
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_256,q_75,strp/<prettyName>-fullview.jpg',
                    h: 256,
                    w: 1024
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_256,q_75,strp/<prettyName>-fullview.jpg',
                    h: 256,
                    w: 1024,
                    f: 282790
                }
            ]
        }
    },
    {
        deviationId: 533828789,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-1300x500-533828789',
        title: 'Thumb Test 1300x500 ',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:49:27-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsxh-18c34444-dd8c-4d35-8881-3f4b8e1171ac.jpg',
            prettyName: 'thumb_test_1300x500__by_superbearpower_d8ttsxh',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9Mzk0IiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0c3hoLTE4YzM0NDQ0LWRkOGMtNGQzNS04ODgxLTNmNGI4ZTExNzFhYy5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.n7Pon2oZXOZc9zBJ7H3VmKrt2bTNNXEL73xZEoMDpew'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 58,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_115,q_70,strp/<prettyName>-200h.jpg',
                    h: 115,
                    w: 300
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_394,q_70,strp/<prettyName>-300w.jpg',
                    h: 115,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_500,h_192,q_70,strp/<prettyName>-250t.jpg',
                    h: 192,
                    w: 500
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_700,h_269,q_70,strp/<prettyName>-350t.jpg',
                    h: 269,
                    w: 700
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_800,h_308,q_70,strp/<prettyName>-400t.jpg',
                    h: 308,
                    w: 800
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_394,q_75,strp/<prettyName>-fullview.jpg',
                    h: 394,
                    w: 1024,
                    f: 184591
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_394,q_75,strp/<prettyName>-fullview.jpg',
                    h: 394,
                    w: 1024
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_394,q_75,strp/<prettyName>-fullview.jpg',
                    h: 394,
                    w: 1024,
                    f: 184591
                }
            ]
        }
    },
    {
        deviationId: 533828782,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-1100x500-533828782',
        title: 'Thumb Test 1100x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T06:49:09-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttsxa-0b4ca34a-8cc6-429b-b9b7-e41b289b03b1.jpg',
            prettyName: 'thumb_test_1100x500_by_superbearpower_d8ttsxa',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NDY2IiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0c3hhLTBiNGNhMzRhLThjYzYtNDI5Yi1iOWI3LWU0MWIyODliMDNiMS5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.uYzMBulNZIfeHNhX1R4h2_nzNsGAqU_wkSIj_qab6jw'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 68,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_136,q_70,strp/<prettyName>-200h.jpg',
                    h: 137,
                    w: 300
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_466,q_70,strp/<prettyName>-300w.jpg',
                    h: 137,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_500,h_227,q_70,strp/<prettyName>-250t.jpg',
                    h: 228,
                    w: 500
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_700,h_318,q_70,strp/<prettyName>-350t.jpg',
                    h: 319,
                    w: 700
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_800,h_364,q_70,strp/<prettyName>-400t.jpg',
                    h: 364,
                    w: 800
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_466,q_75,strp/<prettyName>-fullview.jpg',
                    h: 466,
                    w: 1024,
                    f: 156325
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_466,q_75,strp/<prettyName>-fullview.jpg',
                    h: 466,
                    w: 1024
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_466,q_75,strp/<prettyName>-fullview.jpg',
                    h: 466,
                    w: 1024,
                    f: 156325
                }
            ]
        }
    },
    {
        deviationId: 436651907,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Mature-deviation-436651907',
        title: 'Mature deviation',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T11:15:49-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: true,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 1,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d77yyrn-fa0d49ad-a202-468d-b29e-f07c2d6aabf3.jpg',
            prettyName: 'mature_deviation_by_superbearpower_d77yyrn',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTc2IiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kNzd5eXJuLWZhMGQ0OWFkLWEyMDItNDY4ZC1iMjllLWYwN2MyZDZhYWJmMy5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.6gXseY_yB7CHFMkVQjEHAIT55FegKMx6RhEiHqry0B8'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 84,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_576,q_70,strp/<prettyName>-300w.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_445,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 444
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_623,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 622
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 711
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_576,q_75,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024,
                    f: 91457
                },
                {
                    t: 'social_preview',
                    r: -2,
                    s: 'https://st.deviantart.net/misc/noentrythumb-200.png',
                    h: 200,
                    w: 200
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_576,q_75,strp/<prettyName>-fullview.jpg',
                    h: 576,
                    w: 1024,
                    f: 91457
                }
            ]
        }
    },
    {
        deviationId: 533831116,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-100x100-533831116',
        title: 'Thumb Test 100x100',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:05:26-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttuq4-2c5744ad-7162-44ca-8e1b-c4b104d9fb86.png',
            prettyName: 'thumb_test_100x100_by_superbearpower_d8ttuq4',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0dXE0LTJjNTc0NGFkLTcxNjItNDRjYS04ZTFiLWM0YjEwNGQ5ZmI4Ni5wbmciLCJ3aWR0aCI6Ijw9MTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.mN2QrsceFePVd3YAtamcSl6t5vE8hFs3EKxxdQvPDwk',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVxNC0yYzU3NDRhZC03MTYyLTQ0Y2EtOGUxYi1jNGIxMDRkOWZiODYucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.mzth5PL__S_9KHIOtZ-WVZh9xcioFFlSPu1lnf-SCBI'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,strp/<prettyName>-fullview.png',
                    h: 100,
                    w: 100,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,strp/<prettyName>-fullview.png',
                    h: 100,
                    w: 100,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,strp/<prettyName>-fullview.png',
                    h: 100,
                    w: 100,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,strp/<prettyName>-fullview.png',
                    h: 100,
                    w: 100,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,strp/<prettyName>-fullview.png',
                    h: 100,
                    w: 100,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,strp/<prettyName>-fullview.png',
                    h: 100,
                    w: 100,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,strp/<prettyName>-fullview.png',
                    h: 100,
                    w: 100,
                    o: true,
                    f: 1734
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_100,h_100,strp/<prettyName>-fullview.png',
                    h: 100,
                    w: 100,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 100,
                    w: 100,
                    o: true,
                    f: 1734
                }
            ]
        }
    },
    {
        deviationId: 533831125,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-250x250-533831125',
        title: 'Thumb Test 250x250',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:05:32-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttuqd-feb29ba5-1ba4-4b8f-98e4-c0162e8c445a.png',
            prettyName: 'thumb_test_250x250_by_superbearpower_d8ttuqd',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjUwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0dXFkLWZlYjI5YmE1LTFiYTQtNGI4Zi05OGU0LWMwMTYyZThjNDQ1YS5wbmciLCJ3aWR0aCI6Ijw9MjUwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.yEuZz21VHDIVzprwKqgC6QMnotVHaG9Q2RO91tzmODQ',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVxZC1mZWIyOWJhNS0xYmE0LTRiOGYtOThlNC1jMDE2MmU4YzQ0NWEucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.pSnVYKbeDC0YBYCXq-TH9uhe69pdFXZQqxHbXVdmUvU'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 150,
                    w: 150,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_200,h_200,strp/<prettyName>-200h.png',
                    h: 200,
                    w: 200,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fill/w_250,h_250,strp/<prettyName>-fullview.png',
                    h: 250,
                    w: 250,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_250,h_250,strp/<prettyName>-fullview.png',
                    h: 250,
                    w: 250,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_250,h_250,strp/<prettyName>-fullview.png',
                    h: 250,
                    w: 250,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_250,h_250,strp/<prettyName>-fullview.png',
                    h: 250,
                    w: 250,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_250,h_250,strp/<prettyName>-fullview.png',
                    h: 250,
                    w: 250,
                    o: true,
                    f: 5672
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_250,h_250,strp/<prettyName>-fullview.png',
                    h: 250,
                    w: 250,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 250,
                    w: 250,
                    o: true,
                    f: 5672
                }
            ]
        }
    },
    {
        deviationId: 436618228,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/JPG-image-436618228',
        title: 'JPG image',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T07:35:51-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d77y8s4-f30dcfbd-367e-4ee9-99f4-83fdaad2f321.jpg',
            prettyName: 'jpg_image_by_superbearpower_d77y8s4',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NDUwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kNzd5OHM0LWYzMGRjZmJkLTM2N2UtNGVlOS05OWY0LTgzZmRhYWQyZjMyMS5qcGciLCJ3aWR0aCI6Ijw9ODAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.zZjj8R21VtFzkiodtAEQMYZpX-bJJ0uZ-G2JfXP3wow'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 84,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_450,q_70,strp/<prettyName>-300w.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_445,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 444
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_623,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 622
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 711
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_800,h_450,q_75,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 800,
                    f: 91457
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_800,h_450,q_75,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 800
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_800,h_450,q_75,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 800,
                    f: 91457
                }
            ]
        }
    },
    {
        deviationId: 750477558,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/All-masterpieces-750477558',
        title: 'All masterpieces',
        isJournal: false,
        isPurchasable: true,
        publishedTime: '2018-06-19T03:18:17-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 3,
            favourites: 1
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/dcetc6u-fa70acdb-637c-41a4-b30e-9df29cd847a5.png',
            prettyName: 'all_masterpieces_by_superbearpower_dcetc6u',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MzkxIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kY2V0YzZ1LWZhNzBhY2RiLTYzN2MtNDFhNC1iMzBlLTlkZjI5Y2Q4NDdhNS5wbmciLCJ3aWR0aCI6Ijw9NDAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.Uq_XPFBFJ1g8Rvw-E4SV-3MCA6uReiN-fip_9Z0Ghg0',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZGNldGM2dS1mYTcwYWNkYi02MzdjLTQxYTQtYjMwZS05ZGYyOWNkODQ3YTUucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.p0sSPPZnIbpfy8hElL1JkMoTNGMo5Q3b2vJocf1xCFk'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 147,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_205,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 205
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_391,q_70,strp/<prettyName>-300w.jpg',
                    h: 293,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_256,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 256
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_358,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 358
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_400,h_391,q_80,strp/<prettyName>-fullview.jpg',
                    h: 391,
                    w: 400
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_400,h_391,q_80,strp/<prettyName>-fullview.jpg',
                    h: 391,
                    w: 400,
                    f: 41569
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_400,h_391,q_80,strp/<prettyName>-fullview.jpg',
                    h: 391,
                    w: 400
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 391,
                    w: 400,
                    f: 41569
                }
            ]
        }
    },
    {
        deviationId: 436621799,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Archive-436621799',
        title: 'Archive',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T08:01:08-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1f156103-0873-47d9-a3c8-d64b693702cb/d77ybjb-ad285090-df78-4e38-ab24-e1368df281c6.png',
            prettyName: 'archive_by_superbearpower_d77ybjb',
            types: [
                {
                    t: '150',
                    r: -1,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 147,
                    w: 150
                },
                {
                    t: '200H',
                    r: -1,
                    c: 'v1/fill/w_204,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 204
                },
                {
                    t: '300W',
                    r: -1,
                    c: 'v1/fit/w_300,h_450,q_70,strp/<prettyName>-300w.jpg',
                    h: 293,
                    w: 300
                },
                {
                    t: '250T',
                    r: -1,
                    c: 'v1/fill/w_256,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 256
                },
                {
                    t: '350T',
                    r: -1,
                    c: 'v1/fill/w_358,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 358
                },
                {
                    t: '400T',
                    r: -1,
                    c: 'v1/fill/w_409,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 409
                },
                {
                    t: 'preview',
                    r: -1,
                    c: 'v1/fill/w_460,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 460,
                    f: 45982
                },
                {
                    t: 'social_preview',
                    r: -1,
                    c: 'v1/fill/w_460,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 460
                },
                {
                    t: 'fullview',
                    r: -1,
                    h: 450,
                    w: 460,
                    f: 45982
                }
            ]
        }
    },
    {
        deviationId: 533831225,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-2500x500-533831225',
        title: 'Thumb Test 2500x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:08:07-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttut5-a9a50bbd-6283-4703-b7df-a55df5cd0ce3.png',
            prettyName: 'thumb_test_2500x500_by_superbearpower_d8ttut5',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjA1IiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0dXQ1LWE5YTUwYmJkLTYyODMtNDcwMy1iN2RmLWE1NWRmNWNkMGNlMy5wbmciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.ZpDivchvXdqGTiyp4ocMB4hd3z26gPCluv6-5EQhZC8'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 30,
                    w: 150,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_302,h_100,x_99,y_0,scl_0.2,strp/<prettyName>-200h.png',
                    h: 100,
                    w: 302,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_205,strp/<prettyName>-300w.png',
                    h: 60,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_500,h_100,strp/<prettyName>-250t.png',
                    h: 100,
                    w: 500,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_700,h_140,strp/<prettyName>-350t.png',
                    h: 140,
                    w: 700,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_800,h_160,strp/<prettyName>-400t.png',
                    h: 160,
                    w: 800,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_205,strp/<prettyName>-fullview.png',
                    h: 205,
                    w: 1024,
                    o: true,
                    f: 45858
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_205,strp/<prettyName>-fullview.png',
                    h: 205,
                    w: 1024,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_205,strp/<prettyName>-fullview.png',
                    h: 205,
                    w: 1024,
                    o: true,
                    f: 45858
                }
            ]
        }
    },
    {
        deviationId: 436644952,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Flash-436644952',
        title: 'Flash',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T10:34:53-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1f156103-0873-47d9-a3c8-d64b693702cb/d77yteg-65618ec3-b349-4686-b404-21cc33f44ef2.png',
            prettyName: 'flash_by_superbearpower_d77yteg',
            types: [
                {
                    t: '150',
                    r: -1,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 147,
                    w: 150
                },
                {
                    t: '200H',
                    r: -1,
                    c: 'v1/fill/w_204,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 204
                },
                {
                    t: '300W',
                    r: -1,
                    c: 'v1/fit/w_300,h_450,q_70,strp/<prettyName>-300w.jpg',
                    h: 293,
                    w: 300
                },
                {
                    t: '250T',
                    r: -1,
                    c: 'v1/fill/w_256,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 256
                },
                {
                    t: '350T',
                    r: -1,
                    c: 'v1/fill/w_358,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 358
                },
                {
                    t: '400T',
                    r: -1,
                    c: 'v1/fill/w_409,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 409
                },
                {
                    t: 'preview',
                    r: -1,
                    c: 'v1/fill/w_460,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 460,
                    f: 45982
                },
                {
                    t: 'social_preview',
                    r: -1,
                    c: 'v1/fill/w_460,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 460
                },
                {
                    t: 'fullview',
                    r: -1,
                    h: 450,
                    w: 460,
                    f: 45982
                },
                {
                    t: 'flash',
                    r: -2,
                    s: 'https://sandbox.deviantart.com?fileheight=250&filewidth=300&filename=wixmp%3Af%2F1f156103-0873-47d9-a3c8-d64b693702cb%2Fd77yteg-84a0371f-ab21-4017-a389-39e9a8820d49.swf',
                    h: 250,
                    w: 300,
                    f: 42233
                }
            ]
        }
    },
    {
        deviationId: 436621591,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/File-436621591',
        title: 'File',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T07:59:48-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1f156103-0873-47d9-a3c8-d64b693702cb/d77ybdj-c9f6d2bf-9ccf-4d3f-8e2b-eab969d04974.png',
            prettyName: 'file_by_superbearpower_d77ybdj',
            types: [
                {
                    t: '150',
                    r: -1,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 147,
                    w: 150
                },
                {
                    t: '200H',
                    r: -1,
                    c: 'v1/fill/w_204,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 204
                },
                {
                    t: '300W',
                    r: -1,
                    c: 'v1/fit/w_300,h_450,q_70,strp/<prettyName>-300w.jpg',
                    h: 293,
                    w: 300
                },
                {
                    t: '250T',
                    r: -1,
                    c: 'v1/fill/w_256,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 256
                },
                {
                    t: '350T',
                    r: -1,
                    c: 'v1/fill/w_358,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 358
                },
                {
                    t: '400T',
                    r: -1,
                    c: 'v1/fill/w_409,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 409
                },
                {
                    t: 'preview',
                    r: -1,
                    c: 'v1/fill/w_460,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 460,
                    f: 45982
                },
                {
                    t: 'social_preview',
                    r: -1,
                    c: 'v1/fill/w_460,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 460
                },
                {
                    t: 'fullview',
                    r: -1,
                    h: 450,
                    w: 460,
                    f: 45982
                }
            ]
        }
    },
    {
        deviationId: 436620339,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Muro-image-436620339',
        title: 'Muro image',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T07:52:13-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1f156103-0873-47d9-a3c8-d64b693702cb/d77yaer-cc26c84f-1e90-4938-b82f-0945a493f475.png',
            prettyName: 'muro_image_by_superbearpower_d77yaer',
            types: [
                {
                    t: '150',
                    r: -1,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 85,
                    w: 150
                },
                {
                    t: '200H',
                    r: -1,
                    c: 'v1/fill/w_300,h_170,q_70,strp/<prettyName>-200h.jpg',
                    h: 170,
                    w: 300
                },
                {
                    t: '300W',
                    r: -1,
                    c: 'v1/fit/w_300,h_519,q_70,strp/<prettyName>-300w.jpg',
                    h: 170,
                    w: 300
                },
                {
                    t: '250T',
                    r: -1,
                    c: 'v1/fill/w_441,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 441
                },
                {
                    t: '350T',
                    r: -1,
                    c: 'v1/fill/w_618,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 618
                },
                {
                    t: '400T',
                    r: -1,
                    c: 'v1/fill/w_706,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 706
                },
                {
                    t: 'preview',
                    r: -1,
                    c: 'v1/fill/w_916,h_519,q_80,strp/<prettyName>-fullview.jpg',
                    h: 519,
                    w: 916,
                    f: 277098
                },
                {
                    t: 'social_preview',
                    r: -1,
                    c: 'v1/fill/w_916,h_519,q_80,strp/<prettyName>-fullview.jpg',
                    h: 519,
                    w: 916
                },
                {
                    t: 'fullview',
                    r: -1,
                    h: 519,
                    w: 916,
                    f: 277098
                }
            ]
        }
    },
    {
        deviationId: 533831127,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x500-533831127',
        title: 'Thumb Test 500x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:05:41-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttuqf-df69a1bc-5aec-45dd-a83d-c007ed23ad8e.png',
            prettyName: 'thumb_test_500x500_by_superbearpower_d8ttuqf',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0dXFmLWRmNjlhMWJjLTVhZWMtNDVkZC1hODNkLWMwMDdlZDIzYWQ4ZS5wbmciLCJ3aWR0aCI6Ijw9NTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.tv4bPp3nCBeqDKYXo1Bom_VnZAPg6yt6eJ_tGDLLrl8',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVxZi1kZjY5YTFiYy01YWVjLTQ1ZGQtYTgzZC1jMDA3ZWQyM2FkOGUucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.VQFqfLuaoNwY8gyGSvfTXAHTzNdjxmMHhw_CbJ2oZaQ'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 150,
                    w: 150,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_200,h_200,strp/<prettyName>-200h.png',
                    h: 200,
                    w: 200,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_500,strp/<prettyName>-300w.png',
                    h: 300,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_250,h_250,strp/<prettyName>-250t.png',
                    h: 250,
                    w: 250,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_350,h_350,strp/<prettyName>-350t.png',
                    h: 350,
                    w: 350,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_400,h_400,strp/<prettyName>-400t.png',
                    h: 400,
                    w: 400,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_500,strp/<prettyName>-fullview.png',
                    h: 500,
                    w: 500,
                    o: true,
                    f: 13319
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_500,strp/<prettyName>-fullview.png',
                    h: 500,
                    w: 500,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 500,
                    w: 500,
                    o: true,
                    f: 13319
                }
            ]
        }
    },
    {
        deviationId: 436619204,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/GIF-image-436619204',
        title: 'GIF image',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T07:46:27-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1f156103-0873-47d9-a3c8-d64b693702cb/d77y9j8-2ce5312f-8ea8-4c2c-8f31-fd4e84614022.gif',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDc3eTlqOC0yZTk5MGExOS1jYzhjLTQzNTYtYjVkZi1kYzljN2E3NGFhZTQuZ2lmIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.Q4gT2Hk5n2lCpa9cqy2Afea-pIO6luK8AJu1lfmgpxc'
            ],
            types: [
                {
                    t: '150',
                    r: -1,
                    h: 90,
                    w: 92,
                    o: true
                },
                {
                    t: '200H',
                    r: -1,
                    h: 90,
                    w: 92,
                    o: true
                },
                {
                    t: '300W',
                    r: -1,
                    h: 90,
                    w: 92,
                    o: true
                },
                {
                    t: '250T',
                    r: -1,
                    h: 90,
                    w: 92,
                    o: true
                },
                {
                    t: '350T',
                    r: -1,
                    h: 90,
                    w: 92,
                    o: true
                },
                {
                    t: '400T',
                    r: -1,
                    h: 90,
                    w: 92,
                    o: true
                },
                {
                    t: 'preview',
                    r: -1,
                    h: 90,
                    w: 92,
                    o: true,
                    f: 6978
                },
                {
                    t: 'social_preview',
                    r: -1,
                    h: 90,
                    w: 92,
                    o: true
                },
                {
                    t: 'fullview',
                    r: -1,
                    h: 90,
                    w: 92,
                    o: true,
                    f: 6978
                },
                {
                    t: 'gif',
                    r: 0,
                    h: 90,
                    w: 92,
                    o: true,
                    f: 6978,
                    b: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d77y9j8-2e990a19-cc8c-4356-b5df-dc9c7a74aae4.gif'
                }
            ]
        }
    },
    {
        deviationId: 436620094,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/PNG-Transparent-436620094',
        title: 'PNG, Transparent',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T07:47:38-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d77ya7y-328d2ed5-320c-495b-af02-e743cef70c9a.png',
            prettyName: 'png__transparent_by_superbearpower_d77ya7y',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NDUwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kNzd5YTd5LTMyOGQyZWQ1LTMyMGMtNDk1Yi1hZjAyLWU3NDNjZWY3MGM5YS5wbmciLCJ3aWR0aCI6Ijw9NDYwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.Th0czhqft6l1gIJJKWGFHON6XRHo7MTQ18Ndg1Ik-yc',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDc3eWE3eS0zMjhkMmVkNS0zMjBjLTQ5NWItYWYwMi1lNzQzY2VmNzBjOWEucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.ujnaKGwt3ifmVvo8deG3KT_245VX3QPjLuq7Pc88xbs'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 147,
                    w: 150,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_204,h_200,strp/<prettyName>-200h.png',
                    h: 200,
                    w: 204,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_450,strp/<prettyName>-300w.png',
                    h: 293,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_256,h_250,strp/<prettyName>-250t.png',
                    h: 250,
                    w: 256,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_358,h_350,strp/<prettyName>-350t.png',
                    h: 350,
                    w: 358,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_409,h_400,strp/<prettyName>-400t.png',
                    h: 400,
                    w: 409,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_460,h_450,strp/<prettyName>-fullview.png',
                    h: 450,
                    w: 460,
                    o: true,
                    f: 31487
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_460,h_450,strp/<prettyName>-fullview.png',
                    h: 450,
                    w: 460,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 450,
                    w: 460,
                    o: true,
                    f: 31487
                }
            ]
        }
    },
    {
        deviationId: 533831197,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-900x500-533831197',
        title: 'Thumb Test 900x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:07:27-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttusd-166aecd9-debb-4e3e-8b82-4a8367ca4b5a.png',
            prettyName: 'thumb_test_900x500_by_superbearpower_d8ttusd',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0dXNkLTE2NmFlY2Q5LWRlYmItNGUzZS04YjgyLTRhODM2N2NhNGI1YS5wbmciLCJ3aWR0aCI6Ijw9OTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.gQOCX_7FWVL6x0TILxqGkeCQHPsrMchHKyHOqBW14sk',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVzZC0xNjZhZWNkOS1kZWJiLTRlM2UtOGI4Mi00YTgzNjdjYTRiNWEucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.WHdaAd1U8h8HUflTnB8MGbVfeLaVxX_Rd9WrgiT332U'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 83,
                    w: 150,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_167,strp/<prettyName>-200h.png',
                    h: 167,
                    w: 300,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_500,strp/<prettyName>-300w.png',
                    h: 167,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_450,h_250,strp/<prettyName>-250t.png',
                    h: 250,
                    w: 450,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_630,h_350,strp/<prettyName>-350t.png',
                    h: 350,
                    w: 630,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_720,h_400,strp/<prettyName>-400t.png',
                    h: 400,
                    w: 720,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_900,h_500,strp/<prettyName>-fullview.png',
                    h: 500,
                    w: 900,
                    o: true,
                    f: 20483
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_900,h_500,strp/<prettyName>-fullview.png',
                    h: 500,
                    w: 900,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 500,
                    w: 900,
                    o: true,
                    f: 20483
                }
            ]
        }
    },
    {
        deviationId: 533831195,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-700x500-533831195',
        title: 'Thumb Test 700x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:07:21-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttusb-26e1cab2-89ba-4e0a-a2cd-c4da5221786c.png',
            prettyName: 'thumb_test_700x500_by_superbearpower_d8ttusb',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0dXNiLTI2ZTFjYWIyLTg5YmEtNGUwYS1hMmNkLWM0ZGE1MjIxNzg2Yy5wbmciLCJ3aWR0aCI6Ijw9NzAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.BkdEwdKbHF-Ln7BKWYTuNbfin_wBY4DdOueAa1G5zKk',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVzYi0yNmUxY2FiMi04OWJhLTRlMGEtYTJjZC1jNGRhNTIyMTc4NmMucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.fLnJQvFnpviarL7Slf4-bGe2ymFMjBfvnFWEfPeYCYg'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 107,
                    w: 150,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_280,h_200,strp/<prettyName>-200h.png',
                    h: 200,
                    w: 280,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_500,strp/<prettyName>-300w.png',
                    h: 214,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_350,h_250,strp/<prettyName>-250t.png',
                    h: 250,
                    w: 350,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_490,h_350,strp/<prettyName>-350t.png',
                    h: 350,
                    w: 490,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_560,h_400,strp/<prettyName>-400t.png',
                    h: 400,
                    w: 560,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_700,h_500,strp/<prettyName>-fullview.png',
                    h: 500,
                    w: 700,
                    o: true,
                    f: 17610
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_700,h_500,strp/<prettyName>-fullview.png',
                    h: 500,
                    w: 700,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 500,
                    w: 700,
                    o: true,
                    f: 17610
                }
            ]
        }
    },
    {
        deviationId: 436617715,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/PNG-image-non-transparent-436617715',
        title: 'PNG image, non transparent',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T07:33:24-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d77y8dv-06532a63-d3b2-4664-afbf-c8ae9c622f51.png',
            prettyName: 'png_image__non_transparent_by_superbearpower_d77y8dv',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NDUwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kNzd5OGR2LTA2NTMyYTYzLWQzYjItNDY2NC1hZmJmLWM4YWU5YzYyMmY1MS5wbmciLCJ3aWR0aCI6Ijw9ODAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.x6T7z4AnonMUnbAX1op-QDvKt84pN-W_uo1LKsCXuFs'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 84,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_450,q_70,strp/<prettyName>-300w.jpg',
                    h: 169,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_445,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 444
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_623,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 622
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 711
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_800,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 800,
                    f: 273744
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_800,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 800
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_800,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 800,
                    f: 273744
                }
            ]
        }
    },
    {
        deviationId: 436641455,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/TIFF-image-436641455',
        title: 'TIFF image',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T10:13:31-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1f156103-0873-47d9-a3c8-d64b693702cb/d77yqpb-67169e1c-f4f9-4f78-8b1e-545721d13b61.png',
            prettyName: 'tiff_image_by_superbearpower_d77yqpb',
            types: [
                {
                    t: '150',
                    r: -1,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 147,
                    w: 150
                },
                {
                    t: '200H',
                    r: -1,
                    c: 'v1/fill/w_204,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 204
                },
                {
                    t: '300W',
                    r: -1,
                    c: 'v1/fit/w_300,h_450,q_70,strp/<prettyName>-300w.jpg',
                    h: 293,
                    w: 300
                },
                {
                    t: '250T',
                    r: -1,
                    c: 'v1/fill/w_256,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 256
                },
                {
                    t: '350T',
                    r: -1,
                    c: 'v1/fill/w_358,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 358
                },
                {
                    t: '400T',
                    r: -1,
                    c: 'v1/fill/w_409,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 409
                },
                {
                    t: 'preview',
                    r: -1,
                    c: 'v1/fill/w_460,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 460,
                    f: 34945
                },
                {
                    t: 'social_preview',
                    r: -1,
                    c: 'v1/fill/w_460,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 460
                },
                {
                    t: 'fullview',
                    r: -1,
                    h: 450,
                    w: 460,
                    f: 34945
                }
            ]
        }
    },
    {
        deviationId: 533831138,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x900-533831138',
        title: 'Thumb Test 500x900',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:06:24-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttuqq-6f6192da-94f6-4a72-aa0b-855ef475da6e.png',
            prettyName: 'thumb_test_500x900_by_superbearpower_d8ttuqq',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0dXFxLTZmNjE5MmRhLTk0ZjYtNGE3Mi1hYTBiLTg1NWVmNDc1ZGE2ZS5wbmciLCJ3aWR0aCI6Ijw9NTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.FIHoWr4m3WG9sBGnLc-xGWJGqlIZqJb6BJbPHUCOHwg',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVxcS02ZjYxOTJkYS05NGY2LTRhNzItYWEwYi04NTVlZjQ3NWRhNmUucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.w5n14ViTibp-uTmVePZTDOTSStEhn1zY5u099GJwHAk'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 150,
                    w: 83,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_111,h_200,strp/<prettyName>-200h.png',
                    h: 200,
                    w: 111,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,strp/<prettyName>-300w.png',
                    h: 540,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_139,h_250,strp/<prettyName>-250t.png',
                    h: 250,
                    w: 139,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/crop/w_194,h_350,x_0,y_0,scl_0.39,strp/<prettyName>-350t.png',
                    h: 350,
                    w: 194,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_222,h_400,strp/<prettyName>-400t.png',
                    h: 400,
                    w: 222,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_900,strp/<prettyName>-fullview.png',
                    h: 900,
                    w: 500,
                    o: true,
                    f: 21721
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_900,strp/<prettyName>-fullview.png',
                    h: 900,
                    w: 500,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 900,
                    w: 500,
                    o: true,
                    f: 21721
                }
            ]
        }
    },
    {
        deviationId: 533831134,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x700-533831134',
        title: 'Thumb Test 500x700',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:05:47-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttuqm-6b03ff74-789b-4f98-9488-bc4053e4afcf.png',
            prettyName: 'thumb_test_500x700_by_superbearpower_d8ttuqm',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0dXFtLTZiMDNmZjc0LTc4OWItNGY5OC05NDg4LWJjNDA1M2U0YWZjZi5wbmciLCJ3aWR0aCI6Ijw9NTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.RTwiQW94XOfCwFjcqNSAo4YDLxPBy0pR14FAZV2l8s8',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVxbS02YjAzZmY3NC03ODliLTRmOTgtOTQ4OC1iYzQwNTNlNGFmY2YucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.xKyrvYis7P0N7pR3D1gRclsFfDJok3-VN1TYbUv95tA'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 150,
                    w: 107,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_143,h_200,strp/<prettyName>-200h.png',
                    h: 200,
                    w: 143,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_700,strp/<prettyName>-300w.png',
                    h: 420,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/crop/w_179,h_250,x_0,y_0,scl_0.358,strp/<prettyName>-250t.png',
                    h: 250,
                    w: 179,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_250,h_350,strp/<prettyName>-350t.png',
                    h: 350,
                    w: 250,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_286,h_400,strp/<prettyName>-400t.png',
                    h: 400,
                    w: 286,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_700,strp/<prettyName>-fullview.png',
                    h: 700,
                    w: 500,
                    o: true,
                    f: 17559
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_700,strp/<prettyName>-fullview.png',
                    h: 700,
                    w: 500,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 700,
                    w: 500,
                    o: true,
                    f: 17559
                }
            ]
        }
    },
    {
        deviationId: 533831148,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-500x1000-533831148',
        title: 'Thumb Test 500x1000',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:06:32-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttur0-eed46d98-91ec-4bc5-b713-62dcea3a998d.png',
            prettyName: 'thumb_test_500x1000_by_superbearpower_d8ttur0',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTAwMCIsInBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVyMC1lZWQ0NmQ5OC05MWVjLTRiYzUtYjcxMy02MmRjZWEzYTk5OGQucG5nIiwid2lkdGgiOiI8PTUwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.wJt2sIkq-oW4mg9K6gFSRhlAWLc3jKx74Q-1GNXzmro',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVyMC1lZWQ0NmQ5OC05MWVjLTRiYzUtYjcxMy02MmRjZWEzYTk5OGQucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.IHf0LUHp4qmbrTR23CAroMYxEctZ2l2k-mEpzy0In4M'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 150,
                    w: 75,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_100,h_200,strp/<prettyName>-200h.png',
                    h: 200,
                    w: 100,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_900,strp/<prettyName>-300w.png',
                    h: 600,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_125,h_250,strp/<prettyName>-250t.png',
                    h: 250,
                    w: 125,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_175,h_350,strp/<prettyName>-350t.png',
                    h: 350,
                    w: 175,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_200,h_400,strp/<prettyName>-400t.png',
                    h: 400,
                    w: 200,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1000,strp/<prettyName>-fullview.png',
                    h: 1000,
                    w: 500,
                    o: true,
                    f: 23566
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_500,h_1000,strp/<prettyName>-fullview.png',
                    h: 1000,
                    w: 500,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 1000,
                    w: 500,
                    o: true,
                    f: 23566
                }
            ]
        }
    },
    {
        deviationId: 533831220,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-2000x500-533831220',
        title: 'Thumb Test 2000x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:08:01-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttut0-7d1e1f11-55ce-4c0a-99cd-5f0d9a69c147.png',
            prettyName: 'thumb_test_2000x500_by_superbearpower_d8ttut0',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjU2IiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0dXQwLTdkMWUxZjExLTU1Y2UtNGMwYS05OWNkLTVmMGQ5YTY5YzE0Ny5wbmciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.2Vwra41AquOjcDSQBK9AzQV7P7DZ3jYhIMdfHGAM-qI'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 38,
                    w: 150,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/crop/w_302,h_100,x_49,y_0,scl_0.2,strp/<prettyName>-200h.png',
                    h: 100,
                    w: 302,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_256,strp/<prettyName>-300w.png',
                    h: 75,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_500,h_125,strp/<prettyName>-250t.png',
                    h: 125,
                    w: 500,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_700,h_175,strp/<prettyName>-350t.png',
                    h: 175,
                    w: 700,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_800,h_200,strp/<prettyName>-400t.png',
                    h: 200,
                    w: 800,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_256,strp/<prettyName>-fullview.png',
                    h: 256,
                    w: 1024,
                    o: true,
                    f: 39303
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_256,strp/<prettyName>-fullview.png',
                    h: 256,
                    w: 1024,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_256,strp/<prettyName>-fullview.png',
                    h: 256,
                    w: 1024,
                    o: true,
                    f: 39303
                }
            ]
        }
    },
    {
        deviationId: 533831210,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-1300x500-533831210',
        title: 'Thumb Test 1300x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:07:45-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttusq-9015a6e6-7452-4baf-b0f3-d08b56a8917a.png',
            prettyName: 'thumb_test_1300x500_by_superbearpower_d8ttusq',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9Mzk0IiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0dXNxLTkwMTVhNmU2LTc0NTItNGJhZi1iMGYzLWQwOGI1NmE4OTE3YS5wbmciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.vJLf1rGG4aQonZ3H5hdRN6HQRRJnjgPyr-6kY4xMvi0'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 58,
                    w: 150,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_115,strp/<prettyName>-200h.png',
                    h: 115,
                    w: 300,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_394,strp/<prettyName>-300w.png',
                    h: 115,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_500,h_192,strp/<prettyName>-250t.png',
                    h: 192,
                    w: 500,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_700,h_269,strp/<prettyName>-350t.png',
                    h: 269,
                    w: 700,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_800,h_308,strp/<prettyName>-400t.png',
                    h: 308,
                    w: 800,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_394,strp/<prettyName>-fullview.png',
                    h: 394,
                    w: 1024,
                    o: true,
                    f: 31522
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_394,strp/<prettyName>-fullview.png',
                    h: 394,
                    w: 1024,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_394,strp/<prettyName>-fullview.png',
                    h: 394,
                    w: 1024,
                    o: true,
                    f: 31522
                }
            ]
        }
    },
    {
        deviationId: 533831204,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-1000x500-533831204',
        title: 'Thumb Test 1000x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:07:33-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttusk-50b70387-443c-4da1-bebf-61d5675f25c1.png',
            prettyName: 'thumb_test_1000x500_by_superbearpower_d8ttusk',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0dXNrLTUwYjcwMzg3LTQ0M2MtNGRhMS1iZWJmLTYxZDU2NzVmMjVjMS5wbmciLCJ3aWR0aCI6Ijw9MTAwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.4aa8Zqw_wV9yD5re2oK3jckbAqJqUnThwSLmC6AgTos',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDh0dHVzay01MGI3MDM4Ny00NDNjLTRkYTEtYmViZi02MWQ1Njc1ZjI1YzEucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.YJyjYcI_KJMmo2t4MWo2fN7FILNpP2PyCYTYtuNxnVA'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 75,
                    w: 150,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_150,strp/<prettyName>-200h.png',
                    h: 150,
                    w: 300,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_500,strp/<prettyName>-300w.png',
                    h: 150,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_500,h_250,strp/<prettyName>-250t.png',
                    h: 250,
                    w: 500,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_700,h_350,strp/<prettyName>-350t.png',
                    h: 350,
                    w: 700,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_800,h_400,strp/<prettyName>-400t.png',
                    h: 400,
                    w: 800,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1000,h_500,strp/<prettyName>-fullview.png',
                    h: 500,
                    w: 1000,
                    o: true,
                    f: 25012
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1000,h_500,strp/<prettyName>-fullview.png',
                    h: 500,
                    w: 1000,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 500,
                    w: 1000,
                    o: true,
                    f: 25012
                }
            ]
        }
    },
    {
        deviationId: 533831207,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-1100x500-533831207',
        title: 'Thumb Test 1100x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:07:39-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttusn-b31f9f29-962c-4478-91fe-95eb9089559f.png',
            prettyName: 'thumb_test_1100x500_by_superbearpower_d8ttusn',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NDY2IiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0dXNuLWIzMWY5ZjI5LTk2MmMtNDQ3OC05MWZlLTk1ZWI5MDg5NTU5Zi5wbmciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.eVDSZbfERkEW16BGSZD4DZlsAQuGd5OTZID6ptrldEk'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 68,
                    w: 150,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_136,strp/<prettyName>-200h.png',
                    h: 137,
                    w: 300,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_466,strp/<prettyName>-300w.png',
                    h: 137,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_500,h_227,strp/<prettyName>-250t.png',
                    h: 228,
                    w: 500,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_700,h_318,strp/<prettyName>-350t.png',
                    h: 319,
                    w: 700,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_800,h_364,strp/<prettyName>-400t.png',
                    h: 364,
                    w: 800,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_466,strp/<prettyName>-fullview.png',
                    h: 466,
                    w: 1024,
                    o: true,
                    f: 28428
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_466,strp/<prettyName>-fullview.png',
                    h: 466,
                    w: 1024,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_466,strp/<prettyName>-fullview.png',
                    h: 466,
                    w: 1024,
                    o: true,
                    f: 28428
                }
            ]
        }
    },
    {
        deviationId: 533831214,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Thumb-Test-1500x500-533831214',
        title: 'Thumb Test 1500x500',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-05-18T07:07:55-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d8ttusu-60477e2a-4ad7-4ad2-8329-86ab7e4b647d.png',
            prettyName: 'thumb_test_1500x500_by_superbearpower_d8ttusu',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MzQyIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kOHR0dXN1LTYwNDc3ZTJhLTRhZDctNGFkMi04MzI5LTg2YWI3ZTRiNjQ3ZC5wbmciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.lNhMvRyCHgyTeGRO6xgmEavWIcT9fU_xZ4CJECePaqY'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,strp/<prettyName>-150.png',
                    h: 50,
                    w: 150,
                    o: true
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_100,strp/<prettyName>-200h.png',
                    h: 100,
                    w: 300,
                    o: true
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_342,strp/<prettyName>-300w.png',
                    h: 100,
                    w: 300,
                    o: true
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_500,h_167,strp/<prettyName>-250t.png',
                    h: 167,
                    w: 500,
                    o: true
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_700,h_233,strp/<prettyName>-350t.png',
                    h: 234,
                    w: 700,
                    o: true
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_800,h_267,strp/<prettyName>-400t.png',
                    h: 267,
                    w: 800,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_342,strp/<prettyName>-fullview.png',
                    h: 342,
                    w: 1024,
                    o: true,
                    f: 33670
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_342,strp/<prettyName>-fullview.png',
                    h: 342,
                    w: 1024,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1024,h_342,strp/<prettyName>-fullview.png',
                    h: 342,
                    w: 1024,
                    o: true,
                    f: 33670
                }
            ]
        }
    },
    {
        deviationId: 436646923,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Journal-Skin-436646923',
        title: 'Journal Skin',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-25T10:47:20-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 1,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1f156103-0873-47d9-a3c8-d64b693702cb/d77yux7-6d22a91e-9f0b-450f-bea7-31f75e579ff1.png',
            prettyName: 'journal_skin_by_superbearpower_d77yux7',
            types: [
                {
                    t: '150',
                    r: -1,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 147,
                    w: 150
                },
                {
                    t: '200H',
                    r: -1,
                    c: 'v1/fill/w_204,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 204
                },
                {
                    t: '300W',
                    r: -1,
                    c: 'v1/fit/w_300,h_450,q_70,strp/<prettyName>-300w.jpg',
                    h: 293,
                    w: 300
                },
                {
                    t: '250T',
                    r: -1,
                    c: 'v1/fill/w_256,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 256
                },
                {
                    t: '350T',
                    r: -1,
                    c: 'v1/fill/w_358,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 358
                },
                {
                    t: '400T',
                    r: -1,
                    c: 'v1/fill/w_409,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 409
                },
                {
                    t: 'preview',
                    r: -1,
                    c: 'v1/fill/w_460,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 460,
                    f: 45982
                },
                {
                    t: 'social_preview',
                    r: -1,
                    c: 'v1/fill/w_460,h_450,q_80,strp/<prettyName>-fullview.jpg',
                    h: 450,
                    w: 460
                },
                {
                    t: 'fullview',
                    r: -1,
                    h: 450,
                    w: 460,
                    f: 45982
                }
            ]
        }
    },
    {
        deviationId: 437026825,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Madefire-437026825',
        title: 'Madefire',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2015-02-26T03:37:42-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d787021-f66ce275-c21d-4ffd-9a34-3c775ef9c3fa.jpg',
            prettyName: 'madefire_by_superbearpower_d787021',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kNzg3MDIxLWY2NmNlMjc1LWMyMWQtNGZmZC05YTM0LTNjNzc1ZWY5YzNmYS5qcGciLCJ3aWR0aCI6Ijw9MTUwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.Ldql2zAqAgNxdW84AIh3J_D5us1GR784LoXvvJXU0jk',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDc4NzAyMS1mNjZjZTI3NS1jMjFkLTRmZmQtOWEzNC0zYzc3NWVmOWMzZmEuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.wV1CTGgLmmy4Je3Ovlt43_zL02ZBnutdpDigReE9BUA'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 113
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_150,h_200,q_75,strp/<prettyName>-fullview.jpg',
                    h: 200,
                    w: 150
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fill/w_150,h_200,q_75,strp/<prettyName>-fullview.jpg',
                    h: 200,
                    w: 150
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_150,h_200,q_75,strp/<prettyName>-fullview.jpg',
                    h: 200,
                    w: 150
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_150,h_200,q_75,strp/<prettyName>-fullview.jpg',
                    h: 200,
                    w: 150
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_150,h_200,q_75,strp/<prettyName>-fullview.jpg',
                    h: 200,
                    w: 150
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_150,h_200,q_75,strp/<prettyName>-fullview.jpg',
                    h: 200,
                    w: 150,
                    f: 6958
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_150,h_200,q_75,strp/<prettyName>-fullview.jpg',
                    h: 200,
                    w: 150
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 200,
                    w: 150,
                    f: 6958
                }
            ]
        }
    },
    {
        deviationId: 437026525,
        typeId: 1,
        url: 'https://www.deviantart.com/superbearpower/art/Madefire-deviation-437026525',
        title: 'Madefire deviation',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2014-02-27T06:31:16-0800',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: false,
        isCommentable: false,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: false,
        isAntisocial: true,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 30306810,
            useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
            username: 'superbearpower',
            usericon: 'https://a.deviantart.net/avatars-big/s/u/superbearpower.gif?3',
            type: 'hell-beta',
            isNewDeviant: false,
            details: {
                sex: null,
                age: null,
                joindate: '2014-02-25T06:57:53-0800'
            },
            profile: {
                userIsArtist: true,
                artistLevel: 'Professional',
                artistSpeciality: 'Other',
                realName: '',
                tagline: 'Tests shtuff 🦄',
                website: 'http://'
            },
            stats: {
                watchers: 3,
                friends: 2
            }
        },
        stats: {
            comments: 0,
            favourites: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/1f156103-0873-47d9-a3c8-d64b693702cb/d786ztp-1fac921c-b18f-4037-a28f-7c48cb97bb47.jpg',
            prettyName: 'madefire_deviation_by_superbearpower_d786ztp',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjAwIiwicGF0aCI6IlwvZlwvMWYxNTYxMDMtMDg3My00N2Q5LWEzYzgtZDY0YjY5MzcwMmNiXC9kNzg2enRwLTFmYWM5MjFjLWIxOGYtNDAzNy1hMjhmLTdjNDhjYjk3YmI0Ny5qcGciLCJ3aWR0aCI6Ijw9MTUwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.ChQcIW97vltFG3CdtC-KCjx6PE3ADnYdAgd0vXvRFTw',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzFmMTU2MTAzLTA4NzMtNDdkOS1hM2M4LWQ2NGI2OTM3MDJjYlwvZDc4Nnp0cC0xZmFjOTIxYy1iMThmLTQwMzctYTI4Zi03YzQ4Y2I5N2JiNDcuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.1oiXVgReUqw82lrpwukj_lXaYLURII-ZXkGjqvVtECE'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 113
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_150,h_200,q_75,strp/<prettyName>-fullview.jpg',
                    h: 200,
                    w: 150
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fill/w_150,h_200,q_75,strp/<prettyName>-fullview.jpg',
                    h: 200,
                    w: 150
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_150,h_200,q_75,strp/<prettyName>-fullview.jpg',
                    h: 200,
                    w: 150
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_150,h_200,q_75,strp/<prettyName>-fullview.jpg',
                    h: 200,
                    w: 150
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_150,h_200,q_75,strp/<prettyName>-fullview.jpg',
                    h: 200,
                    w: 150
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_150,h_200,q_75,strp/<prettyName>-fullview.jpg',
                    h: 200,
                    w: 150,
                    f: 6958
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_150,h_200,q_75,strp/<prettyName>-fullview.jpg',
                    h: 200,
                    w: 150
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 200,
                    w: 150,
                    f: 6958
                }
            ]
        }
    }
];
